<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="设备" prop="deviceId">
        <el-input v-model="dataForm.deviceId" placeholder="设备ID" disabled></el-input>
      </el-form-item>
      <el-form-item label="因子编码" prop="code">
        <el-input v-model="dataForm.code" placeholder="因子编码"></el-input>
      </el-form-item>
      <el-form-item label="因子名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="因子名称"></el-input>
        <div style="position: absolute;top: 0px;right: 0px;">
          <el-dropdown placement="bottom" trigger="click" @command="clickDropdown">
            <el-button>插入下标</el-button>
            <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
              <el-dropdown-item command="₀">₀</el-dropdown-item>
              <el-dropdown-item command="₁">₁</el-dropdown-item>
              <el-dropdown-item command="₂">₂</el-dropdown-item>
              <el-dropdown-item command="₃">₃</el-dropdown-item>
              <el-dropdown-item command="₄">₄</el-dropdown-item>
              <el-dropdown-item command="₅">₅</el-dropdown-item>
              <el-dropdown-item command="₆">₆</el-dropdown-item>
              <el-dropdown-item command="₇">₇</el-dropdown-item>
              <el-dropdown-item command="₈">₈</el-dropdown-item>
              <el-dropdown-item command="₉">₉</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-form-item>
      <el-form-item label="因子单位" prop="unit">
        <el-input v-model="dataForm.unit" placeholder="单位"></el-input>
        <div style="position: absolute;top: 0px;right: 0px;">
          <el-dropdown placement="bottom" trigger="click" @command="clickDropdownunit">
            <el-button>插入上标</el-button>
            <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
              <el-dropdown-item command="⁰">⁰</el-dropdown-item>
              <el-dropdown-item command="¹">¹</el-dropdown-item>
              <el-dropdown-item command="²">²</el-dropdown-item>
              <el-dropdown-item command="³">³</el-dropdown-item>
              <el-dropdown-item command="⁴">⁴</el-dropdown-item>
              <el-dropdown-item command="⁵">⁵</el-dropdown-item>
              <el-dropdown-item command="⁶">⁶</el-dropdown-item>
              <el-dropdown-item command="⁷">⁷</el-dropdown-item>
              <el-dropdown-item command="⁸">⁸</el-dropdown-item>
              <el-dropdown-item command="⁹">⁹</el-dropdown-item>
              <el-dropdown-item command="ⁿ">ⁿ</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-form-item>
      <el-form-item label="报警模式" prop="alarmType">
        <el-select v-model="dataForm.alarmType" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in alarmTypeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级预警" prop="firstAlarmValue">
        <el-input v-model="dataForm.firstAlarmValue" placeholder="一级预警值"></el-input>
      </el-form-item>
      <el-form-item label="二级预警" prop="secondAlarmValue">
        <el-input v-model="dataForm.secondAlarmValue" placeholder="二级预警值"></el-input>
      </el-form-item>
      <el-form-item label="描述信息" prop="note">
        <el-input v-model="dataForm.note" placeholder="描述信息"></el-input>
      </el-form-item>
      <el-tooltip class="item" effect="dark" content="请填写设备实际监测通道因子的顺序，否则数据会错乱！设备最多监测15个通道因子。如果是计算值（设备非监测值），请从16-25选择写入"
                  placement="top">
        <el-form-item label="监测顺序" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
        </el-form-item>
      </el-tooltip>
      <el-form-item label="因子类型" prop="type">
        <el-select v-model="dataForm.type" placeholder="请选择类型" style="width: 100%">
          <el-option
            v-for="item in typeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      typeOption: [{
        label: '监测值',
        value: 0,
      }, {
        label: '计算值',
        value: 1,
      }],
      alarmTypeOption: [{
        label: '高报模式',
        value: 0,
      }, {
        label: '低报模式',
        value: 1,
      }, {
        label: '区间报警模式',
        value: 2,
      }],
      dataForm: {
        id: 0,
        deviceId: '',
        code: '',
        name: '',
        unit: '',
        firstAlarmValue: '',
        secondAlarmValue: '',
        note: '',
        status: '',
        sort: '',
        recordValue: '',
        type: '',
      },
      dataRule: {
        code: [
          {required: true, message: '因子编码不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '因子名称不能为空', trigger: 'blur'}
        ],
        firstAlarmValue: [
          {required: true, message: '第一预警值不能为空', trigger: 'blur'}
        ],
        secondAlarmValue: [
          {required: true, message: '第二预警值不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    clickDropdown(command) {
      this.dataForm.name = this.dataForm.name + command;
    },
    clickDropdownunit(command) {
      this.dataForm.unit = this.dataForm.unit + command;
    },
    init(id) {
      this.dataForm = {}
      //根据传来id的值，区分新增、修改
      if (!id.deviceId) {
        this.dataForm.id = id
        //获取id设备的信息
        this.$nextTick(() => {
          this.$http({
            url: this.$http.adornUrl("/deviceChannel/list"),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        })
      } else {//新增
        //情况form表单里的值
        this.dataForm.deviceId = id.deviceId
      }
      this.visible = true
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/deviceChannel/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || null,
              'deviceId': this.dataForm.deviceId,
              'code': this.dataForm.code,
              'name': this.dataForm.name,
              'unit': this.dataForm.unit,
              'firstAlarmValue': this.dataForm.firstAlarmValue,
              'secondAlarmValue': this.dataForm.secondAlarmValue,
              'note': this.dataForm.note,
              'sort': this.dataForm.sort,
              'recordValue': this.dataForm.recordValue,
              'type': this.dataForm.type,
              'alarmType': this.dataForm.alarmType,
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/devicechannel-add-or-update.vue